export type Theme = "slalom-light-theme" | "slalom-dark-theme" | "midnight-dark-theme";

export const validThemes: Theme[] = [
  "slalom-light-theme",
  "slalom-dark-theme",
  "midnight-dark-theme",
];
